import graphql from './graphql';

const query = /* GraphQL */ `
  query User($id: ID) {
    User(id: $id) {
      id
      payrollNum
      fullName
      status
      Terminal {
        name
      }
      JobTitle {
        name
      }
      Department {
        name
      }
      Role {
        name
      }
      entryDate
    }
  }
`;

const UserFindById = async ({ id }) =>
  graphql(query, { id }).then(
    // eslint-disable-next-line camelcase
    ({ User }) => User
  );

export default UserFindById;
